import { useRuntimeConfigKey, type UseRuntimeConfig } from '@/injectionKeys';
import { buildOtonamiAdminUrl } from '@/utils/urlBuilder';

/**
 * Otonami 側の管理画面へのリンクを組み立てる
 *
 * Wabunka の管理画面は admin-wabunka.* という別ドメインで配信されるため、
 * Otonami 側の画面へのリンクは相対パスではなく絶対 URL にする必要がある
 */
export const useOtonamiAdminUrl = () => {
  const useRuntimeConfig = inject(useRuntimeConfigKey) as UseRuntimeConfig;
  // 生成される runtimeConfig の型に載らず unknown になるため、ここで文字列として受ける
  const otonamiAdminUrl = useRuntimeConfig().public.OTONAMI_ADMIN_URL as string;

  return (path: string) => buildOtonamiAdminUrl(path, otonamiAdminUrl);
};
